import { Alert, Typography } from '@mui/material';
import { useConsentUserInfo, useLoading } from 'components/common/ConsentPreferenceBase';
import PreferenceCenterForm from 'components/common/Forms/PreferenceCenterForm';
import LoadingIndicator from 'components/common/LoadingIndicator';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import GetContentTypeResponse from 'services/newsletter/GetContentTypeResponse';
import { GetContentType } from 'services/newsletter/NewsLetterService';

const PreferenceCenter = (): JSX.Element => {
  const { t } = useTranslation('component');

  const [fetchErrorMsg, setFetchErrorMsg] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { isLoading, setIsLoading } = useLoading();
  const { consentUserInfo } = useConsentUserInfo();

  const [contentTypeInfo, setContentTypeInfo] = useState<GetContentTypeResponse>();

  useEffect(() => {
    const GetUserContentType = async () => {
      const userContentTypeResponse = await GetContentType(consentUserInfo.Email ?? '', consentUserInfo.Identifier);
      if (userContentTypeResponse.ok) {
        const userContentType: GetContentTypeResponse = await userContentTypeResponse.json();
        setContentTypeInfo(userContentType);
      } else {
        setFetchErrorMsg('Errors.GetProfileError');
      }

      setIsLoading(false);
    };

    if (consentUserInfo.Identifier == '' || !consentUserInfo.Email) {
      setErrorMessage('Errors.GenericError');
      setIsLoading(false);
    } else {
      GetUserContentType();
    }
  }, [setIsLoading, consentUserInfo]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.PreferenceCenterTitle')}</title>
        <meta name="description" content={t('MetaTag.PreferenceCenterDescription').toString()} />
      </Helmet>
      <Typography sx={{ display: 'block', padding: '25px 0' }} variant="title">
        {t('PreferenceCenter.Title')}
      </Typography>
      <Typography sx={{ marginBottom: '25px' }} variant="body1">
        {t('PreferenceCenter.Description')}
      </Typography>
      {(errorMessage || fetchErrorMsg) && (
        <Alert data-cy="form-error" severity="error" sx={{ mb: '16px' }}>
          {t(errorMessage ? errorMessage : fetchErrorMsg)}
        </Alert>
      )}
      {!contentTypeInfo && isLoading && <LoadingIndicator />}
      {contentTypeInfo && (
        <PreferenceCenterForm
          ContentTypeInfo={contentTypeInfo}
          setErrorMessage={setErrorMessage}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}
    </>
  );
};

export default PreferenceCenter;
